import React from 'react';
import { tokenizeQueryForHighlight, toneClass } from 'searchTokenHighlight';

// Renders a search-syntax example with the same per-token colors as the
// live search bar overlay, so the help text visually matches what a user
// sees while typing.
const HighlightedQuery = ({ query, knownTokens, isDark }) => {
  const segments = tokenizeQueryForHighlight(query, knownTokens);
  return (
    <code className="font-mono" data-testid="highlighted-query">
      {segments.map((segment, index) => (
        <span key={index} className={toneClass(segment.kind, isDark)}>
          {segment.text}
        </span>
      ))}
    </code>
  );
};

export default HighlightedQuery;
